module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isInitial || _vm.isSaving) ? _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "id": "file",
      "multiple": "",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving
    },
    on: {
      "change": function($event) {
        return _vm.filesChange($event.target.name, $event.target.files)
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "icon-cloud-upload"
  }), _vm._v(" "), _c('p', [_vm._v("Arraste seu arquivo aqui")]), _vm._v(" "), _c('p', [_vm._v("ou")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', {
    staticClass: "center"
  }, [_vm._v("\n      Salvando...\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSuccess) ? _c('div', [_c('div', {
    staticClass: "image-list"
  }, _vm._l((_vm.uploadedFiles), function(image) {
    return (_vm.uploadedFiles.length) ? _c('div', {
      key: image,
      staticClass: "product-image"
    }, [_c('img', {
      attrs: {
        "src": image,
        "alt": ""
      }
    })]) : _vm._e()
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('button', {
    staticClass: "btn btn--success"
  }, [_vm._v("Buscar no computador")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-270cb447","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/UploadImage.vue
// module id = 2999
// module chunks = 0